import React from 'react';
import Icon from '../UI/Icon';
import '../../../static/scss/components/singleDatePickerFallback.scss';

export const SingleDatePickerFallback = () => (
  <div className="c-single-date-picker-fallback SingleDatePicker SingleDatePicker_1">
    <Icon icon="loading-wheel-primary" width={25} />
  </div>
);

export const SingleDatePickerInputFallback = () => (
  <div
    className="SingleDatePicker c-single-date-picker-input-fallback  SingleDatePicker_1"
    style={{ height: '48px' }}
  >
    <Icon icon="loading-wheel-primary" width={30} />
  </div>
);

export default SingleDatePickerFallback;
